import { useEffect, useState } from "react";
import { useFetch } from "../../../../hooks/useFetch";
import { CanvasMarker, SensorSlotData, SensorType } from "../../../../types/types";
import BaseChartInReport from "../../../../ui/Charts/baseChartInReport";
import Spinner from "../../../../ui/Spinner/Spinner";
import { t } from "i18next";
import { Duration } from "luxon";



type Props = {
  sensorId: number,
  equipmentId: string,
  selectedDate: {
    from: Date,
    to: Date,
  }
  markers?: CanvasMarker[] | undefined
};

const DeviceSensorDataInReport = ({ sensorId, selectedDate, equipmentId, markers = []}: Props) => {
  const [sensorType, setSensorType] = useState<SensorType>()
  const [sensorData, setSensorData] = useState<any>()
  const [loading, setLoading] = useState(true)
  const [dates, setDates] = useState({from: selectedDate?.from?.toISOString(), to: selectedDate?.to?.toISOString()})
  const [periodUsageData, setPeriodUsageData] = useState<any>()

  const [{ response: itemResponse, isLoading: itemIsLoading, error: itemNetworkError }, doFetch] =
    useFetch(`/devices/sensors/${sensorId}/received_data?from=${dates.from}&to=${dates.to}`);

  const [{ response: itemPeriodUsageDataResponse, isLoading: itemPeriodUsageDataIsLoading, error: itemPeriodUsageDataNetworkError }, doFetchPeriodUsageData] =
    useFetch(`/directories/ng_equipment_items_data/period_usage_data?from=${dates.from}&to=${dates.to}&equipment_item_ids[]=${equipmentId}`);


  useEffect(() => {
    if(!selectedDate.to || !selectedDate.from) { return }
    setDates({from: selectedDate?.from?.toISOString(), to: selectedDate?.to?.toISOString()})
  }, [selectedDate])

  useEffect(() => {
    if(!dates.to || !dates.from) { return }    
    doFetch()
    doFetchPeriodUsageData()
    setLoading(true)
  }, [sensorId, dates])

  useEffect(() => {
    if(itemIsLoading) { return }
    setSensorType(itemResponse?.data.attributes.sensor_type)
    setSensorData(itemResponse?.data.attributes.data)
    setLoading(false)
  }, [itemResponse])

  useEffect(() => {
    if(itemPeriodUsageDataIsLoading) { return }
    setPeriodUsageData(itemPeriodUsageDataResponse?.data)
  }, [itemPeriodUsageDataResponse])


  return (
    ["rfid", "rfid_hold"].includes(sensorType?.data_key_name!) ? <></> :
    <>
      <div className="flex h-16 w-full gap-4 items-center px-2">
        {periodUsageData && periodUsageData.length > 0 ?
        <>
          <div className="flex flex-col text-sm w-32">
            <span>{t('worked')}</span>
            <span>{((periodUsageData[0].worked / (periodUsageData[0].worked + periodUsageData[0].stopped + periodUsageData[0].turned_off)) * 100).toFixed(1)}% ({Duration.fromObject({seconds: periodUsageData[0].worked}).toFormat("hh:mm:ss")})</span>
          </div>
          <div className="flex flex-col text-sm w-32">
            <span>{t('stopped')}</span>
            <span>{((periodUsageData[0].stopped / (periodUsageData[0].worked + periodUsageData[0].stopped + periodUsageData[0].turned_off)) * 100).toFixed(1)}% ({Duration.fromObject({seconds: periodUsageData[0].stopped}).toFormat("hh:mm:ss")})</span>
          </div>
          <div className="flex flex-col text-sm w-32">
            <span>{t('turned_off')}</span>
            <span>{((periodUsageData[0].turned_off / (periodUsageData[0].worked + periodUsageData[0].stopped + periodUsageData[0].turned_off)) * 100).toFixed(1)}% ({Duration.fromObject({seconds: periodUsageData[0].turned_off}).toFormat("hh:mm:ss")})</span>
          </div>
        </>
        :
        <></>
        }
      </div>
      <BaseChartInReport
        data={sensorData} 
        type={sensorType?.data_key_name!} 
        title={sensorType?.name!} 
        selectedDate={selectedDate} 
        markers={markers}
        dates={dates} 
        onChangeDates={setDates}
        loading={loading}
      />
    </>
  );
};

export default DeviceSensorDataInReport;
